<template>
    <div id="app">
        <router-view name="header"></router-view>
        <main>
            <fade-transition origin="center" mode="out-in" :duration="250">
                <router-view/>
            </fade-transition>
        </main>
        <router-view name="footer"></router-view>
        <a href="https://wa.me/2348083972277" target="_blank" class="whatsapp-float">
            <i class="fa fa-whatsapp whatsapp-icon"></i>
        </a>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition
  },
  // mounted() {
  // function initFreshChat() {
  //   window.fcWidget.init({
  //     token: "8b40c1c0-c70a-4b09-9563-d9648de0b98d",
  //     host: "https://wchat.freshchat.com"
  //   });
  // }
  // function initialize(i,t){var e;i.getElementById(t)?initFreshChat():((e=i.createElement("script")).id=t,e.async=!0,e.src="https://wchat.freshchat.com/js/widget.js",e.onload=initFreshChat,i.head.appendChild(e))}function initiateCall(){initialize(document,"freshchat-js-sdk")}window.addEventListener?window.addEventListener("load",initiateCall,!1):window.attachEvent("load",initiateCall,!1);
  // }
};
</script>

<style>
.whatsapp-float {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 100px;
  right: 20px;
  background-color: #25d366;
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  font-size: 35px;
  box-shadow: 2px 2px 3px #999;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;
}
.whatsapp-float:hover {
  color: #FFF;
  transform: scale(1.1);
  box-shadow: 2px 2px 5px #777;
}
</style>
